<app-breadcrumb
  *ngIf="!mod"
  [master]="'Dobry Agent'"
  [parentName]="'Kategorie'"
  [name]="isEditMode ? 'Edytuj' : 'Dodaj'"
></app-breadcrumb>

<div class="categories-add-container" fxLayout="column" fxLayoutGap="15px">

  <div *ngIf="loading" class="da-category-form-loader">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <form
    *ngIf="!loading"
    #categoryForm="ngForm"
    class="da-category-form"
    (ngSubmit)="save(categoryForm)"
    fxLayout="column"
    fxFlex="100"
    fxFlex.lt-md="100"
    fxLayoutGap="15px"
  >
    <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="saving"
      >
        <mat-icon>save</mat-icon>
        <span>{{ saving ? ' Zapisywanie...' : ' Zapisz' }}</span>
      </button>

      <button
        *ngIf="!isEditMode && !mod"
        mat-raised-button
        color="accent"
        type="button"
        (click)="save(categoryForm, true)"
        [disabled]="saving"
      >
        <mat-icon>save</mat-icon>
        <span> Zapisz i dodaj kolejną</span>
      </button>

      <button
        mat-stroked-button
        type="button"
        (click)="cancel()"
        [disabled]="saving"
        color="warn"
      >
        <mat-icon> cancel </mat-icon>
        <span>{{ mod ? ' Zamknij' : ' Anuluj' }}</span>
      </button>

    </div>
    <div
      class="category-form-columns"
      fxLayout="row"
      fxLayout.lt-lg="column"
      fxLayoutGap="15px"
      fxFlex="100"
    >
      <mat-card
        class="category-form-card"
        fxLayout="column"
        fxFlex="50"
        fxFlex.lt-lg="100"
      >
        <app-section-header
          title="{{ isEditMode ? 'Edytuj kategorię' : 'Dodaj kategorię' }}"
          description="{{ isEditMode ? 'Zmień podstawowe dane i ustawienia kategorii.' : 'Uzupełnij podstawowe dane i ustawienia kategorii.' }}"
        ></app-section-header>

        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
          <mat-form-field fxFlex="70">
            <mat-label>Nazwa kategorii</mat-label>

            <input
              matInput
              name="name"
              required
              maxlength="100"
              placeholder="Np. Ubezpieczenia"
              [(ngModel)]="model.name"
              #name="ngModel"
              (ngModelChange)="clearBackendError(categoryForm, 'name')"
            >

            <mat-error *ngIf="name.errors?.required && name.touched">
              Nazwa kategorii jest wymagana.
            </mat-error>

            <mat-error *ngIf="name.errors?.backend && name.touched">
              {{ name.errors.backend }}
            </mat-error>
          </mat-form-field>

          <mat-form-field fxFlex="30">
            <mat-label>Pozycja</mat-label>

            <input
              matInput
              type="number"
              name="position"
              required
              placeholder="Np. 1"
              [(ngModel)]="model.position"
              #position="ngModel"
              (ngModelChange)="clearBackendError(categoryForm, 'position')"
            >

            <mat-error *ngIf="position.errors?.required && position.touched">
              Pozycja jest wymagana.
            </mat-error>

            <mat-error *ngIf="position.errors?.backend && position.touched">
              {{ position.errors.backend }}
            </mat-error>
          </mat-form-field>
        </div>

        <div
          fxFlex="100"
          [formGroup]="categoryReactiveForm"
          fxLayout="column"
          fxLayoutGap="8px"
        >
          <label class="editor-label">Opis</label>

          <angular-editor
            formControlName="description"
            [config]="editorConfig"
            (ngModelChange)="clearDescriptionBackendError()"
          ></angular-editor>

          <mat-error
            *ngIf="categoryReactiveForm.get('description')?.errors?.required && categoryReactiveForm.get('description')?.touched"
          >
            Opis jest wymagany.
          </mat-error>

          <mat-error
            *ngIf="categoryReactiveForm.get('description')?.errors?.backend && categoryReactiveForm.get('description')?.touched"
          >
            {{ categoryReactiveForm.get('description')?.errors?.backend }}
          </mat-error>
        </div>


        <div fxLayout="column" fxLayoutGap="8px" style="margin-top: 15px;">
          <label class="editor-label">Ikona kategorii</label>



          <div *ngIf="selectedIconFileName" class="selected-file-name">
            Wybrany plik: {{ selectedIconFileName }}
          </div>

          <ng-container *ngIf="isEditMode && model.icon && !selectedIconFileName">
            <div class="selected-file-name">
              Aktualna ikona:
              <img src="{{ model.icon }}" alt="Aktualna ikona" class="selected-icon-image">
            </div>
          </ng-container>
        </div>
        <div
          fxLayout="row"
          fxLayoutGap="15px"
          fxLayoutAlign="start center"
          style="margin-top: 15px;"
        >
          <input
            #iconInput
            type="file"
            accept="image/*"
            hidden
            (change)="onIconSelected($event)"
          >

          <button
            mat-stroked-button
            color="primary"
            type="button"
            (click)="iconInput.click()"
            [disabled]="saving || deletingIcon"
          >
            <mat-icon>upload</mat-icon>

            <span>
      {{
                model.icon || selectedIconFile
                  ? ' Zmień ikonę'
                  : ' Wybierz ikonę'
              }}
    </span>
          </button>

          <button
            *ngIf="selectedIconFile"
            mat-stroked-button
            color="warn"
            type="button"
            (click)="clearSelectedIcon(iconInput)"
            [disabled]="saving || deletingIcon"
          >
            <mat-icon>close</mat-icon>
            <span> Usuń wybraną</span>
          </button>

          <button
            *ngIf="
      isEditMode
      && model.icon
      && !selectedIconFile
    "
            mat-stroked-button
            color="warn"
            type="button"
            (click)="deleteCurrentIcon()"
            [disabled]="saving || deletingIcon"
          >
            <mat-icon>
              {{ deletingIcon ? 'hourglass_empty' : 'delete' }}
            </mat-icon>

            <span>
      {{
                deletingIcon
                  ? ' Usuwanie...'
                  : ' Usuń ikonę'
              }}
    </span>
          </button>
        </div>
        <mat-form-field fxFlex="100" style="margin-top: 15px;">
          <mat-label>Alt obrazka</mat-label>

          <input
            matInput
            name="altImage"
            required
            maxlength="255"
            placeholder="Opis alternatywny obrazka"
            [(ngModel)]="model.altImage"
            #altImage="ngModel"
            (ngModelChange)="clearBackendError(categoryForm, 'altImage')"
          >

          <mat-error *ngIf="altImage.errors?.required && altImage.touched">
            Alt obrazka jest wymagany.
          </mat-error>

          <mat-error *ngIf="altImage.errors?.backend && altImage.touched">
            {{ altImage.errors.backend }}
          </mat-error>
        </mat-form-field>
        <mat-slide-toggle
          color="accent"
          name="active"
          [(ngModel)]="model.active"
        >
          Aktywna
        </mat-slide-toggle>
      </mat-card>
      <mat-card
        class="category-form-card"
        fxLayout="column"
        fxFlex="50"
        fxFlex.lt-lg="100"

      >
        <app-section-header
          title="{{ isEditMode ? 'SEO' : 'SEO' }}"
          description="{{ isEditMode ? 'Zmień dane wykorzystywane w wynikach wyszukiwania.' : 'Uzupełnij dane wykorzystywane w wynikach wyszukiwania.' }}"
        ></app-section-header>

        <mat-form-field fxFlex="100">
          <mat-label>SEO slug</mat-label>

          <input
            matInput
            name="seoSlug"
            required
            maxlength="255"
            placeholder="np. ubezpieczenia-komunikacyjne"
            [(ngModel)]="model.seoSlug"
            #seoSlug="ngModel"
            (ngModelChange)="clearBackendError(categoryForm, 'seoSlug')"
          >

          <mat-error *ngIf="seoSlug.errors?.required && seoSlug.touched">
            SEO slug jest wymagany.
          </mat-error>

          <mat-error *ngIf="seoSlug.errors?.backend && seoSlug.touched">
            {{ seoSlug.errors.backend }}
          </mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100">
          <mat-label>SEO title</mat-label>

          <input
            matInput
            name="seoTitle"
            required
            maxlength="255"
            placeholder="Tytuł SEO"
            [(ngModel)]="model.seoTitle"
            #seoTitle="ngModel"
            (ngModelChange)="clearBackendError(categoryForm, 'seoTitle')"
          >

          <mat-error *ngIf="seoTitle.errors?.required && seoTitle.touched">
            SEO title jest wymagany.
          </mat-error>

          <mat-error *ngIf="seoTitle.errors?.backend && seoTitle.touched">
            {{ seoTitle.errors.backend }}
          </mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100">
          <mat-label>SEO description</mat-label>

          <textarea
            matInput
            name="seoDescription"
            required
            rows="3"
            placeholder="Opis SEO"
            [(ngModel)]="model.seoDescription"
            #seoDescription="ngModel"
            (ngModelChange)="clearBackendError(categoryForm, 'seoDescription')"
          ></textarea>

          <mat-error *ngIf="seoDescription.errors?.required && seoDescription.touched">
            SEO description jest wymagany.
          </mat-error>

          <mat-error *ngIf="seoDescription.errors?.backend && seoDescription.touched">
            {{ seoDescription.errors.backend }}
          </mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100">
          <mat-label>SEO keywords</mat-label>

          <input
            matInput
            name="seoKeywords"
            required
            maxlength="255"
            placeholder="słowo kluczowe, kolejne słowo"
            [(ngModel)]="model.seoKeywords"
            #seoKeywords="ngModel"
            (ngModelChange)="clearBackendError(categoryForm, 'seoKeywords')"
          >

          <mat-error *ngIf="seoKeywords.errors?.required && seoKeywords.touched">
            SEO keywords są wymagane.
          </mat-error>

          <mat-error *ngIf="seoKeywords.errors?.backend && seoKeywords.touched">
            {{ seoKeywords.errors.backend }}
          </mat-error>
        </mat-form-field>
      </mat-card>
    </div>
    <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">

      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="categoryForm.invalid || saving"
      >
        <mat-icon>save</mat-icon>
        <span>{{ saving ? ' Zapisywanie...' : ' Zapisz' }}</span>
      </button>

      <button
        *ngIf="!isEditMode && !mod"
        mat-raised-button
        color="accent"
        type="button"
        (click)="save(categoryForm, true)"
        [disabled]="categoryForm.invalid || saving"
      >
        <mat-icon>save</mat-icon>
        <span> Zapisz i dodaj kolejną</span>
      </button>

      <button
        mat-stroked-button
        type="button"
        (click)="cancel()"
        [disabled]="saving"
        color="warn"
      >
        <mat-icon> cancel </mat-icon>
        <span>{{ mod ? ' Zamknij' : ' Anuluj' }}</span>
      </button>

    </div>
  </form>
</div>
